import { IProduct } from "../../api/product/ProductsApi";
import { IResellerInfo } from "../../api/reseller/ResellersApi";
import { IManufacturerBid, ISearchResult } from "../../api/search/SearchApi";
import { IDocument } from "../document/Document";
import { Product } from "../product/Product";
import Reseller from "../reseller/Reseller";

interface IStoreSearchResult { }

export default class SearchResult {
  constructor(
    public contentType: string,
    public priority: string,
    public content: IStoreSearchResult | Product | Reseller,
    public newContent: any
  ) { }

  public static convertFrom(source: ISearchResult, newContent: any): SearchResult {
    let searchResult: IStoreSearchResult | Product | Reseller;

    switch (source.ContentType) {
      case "Document":
        searchResult = DocumentSearchResult.convertFrom(source.Content as IDocument); break;
      case "Reseller":
        searchResult = Reseller.convertFrom(source.Content as IResellerInfo); break;
      case "Opportunity":
        searchResult = ManufacturerBid.convertFrom(source.Content as IManufacturerBid); break;
      case "Product":
        searchResult = Product.convertFrom(source.Content as IProduct); break;
      default:
        searchResult = new DefaultSearchResult("Enventually something"); break;
    }

    return new SearchResult(source.ContentType, source.Priority, searchResult, newContent);
  }
}

class DefaultSearchResult implements IStoreSearchResult {
  constructor(
    public contentTitle: string
  ) { }
}

export class DocumentSearchResult implements IStoreSearchResult {
  constructor(
    public documentNumber?: string,
    public location?: string,
    public subTotal?: number
  ) { }
  public static convertFrom(source: IDocument): DocumentSearchResult {
    return new DocumentSearchResult(
      source.DocumentNumber || "",
      source.Location,
      source.SubTotal
    );
  }
}

export class ManufacturerBid implements IStoreSearchResult {
  constructor(
    public active: boolean,
    public lastUpdate: string,
    public bidNumber: string,
    public manufacturerId: string,
    public opportunity: string,
    public startDate: string,
    public endDate: string) { }

  public static convertFrom(source: IManufacturerBid): ManufacturerBid {
    return new ManufacturerBid(source.Active, source.LastUpdate, source.BidNumber, source.ManufacturerId, source.Opportunity, source.StartDate, source.EndDate);
  }
}
